import Paragraph from "antd/lib/typography/Paragraph";
import JuzgadoLayout from "../components/JuzgadoLayout";
import { Button, Form, Input, message, Table } from "antd";
import { useRef, useState } from "react";
import useConfiguracionJuzgadoApi from "../../juzgado-configuraciones/useJuzgadoConfiguracionApi";
import { AxiosError } from "axios";
import ActaPreview, { ActaPreviewRef } from "../../infracciones/components/ActaPreview";
import Modal from "antd/lib/modal/Modal";
import { DataTableRef } from "../../common/components/DataTable";
import moment from "moment-business-days";
import { InfraccionJuzgadoImpaga } from "../hooks/useJuzgadoInfraccionAPI";

const LibreDeuda = () => {
    const refTable = useRef<DataTableRef>(null!);
    const api = useConfiguracionJuzgadoApi();    
    const [ cuitCuil, setCuitCuilt ] = useState<string>("");
    const [ loading, setLoading ] = useState<boolean>(false);
    const [ libreDeuda, setLibreDeuda ] = useState<string>();
    const [ impagas, setImpagas ] = useState({ total: 0, cuitCuil: "" });
    const [ infraccionesImpagas, setInfraccionesImpagas ] = useState<InfraccionJuzgadoImpaga[]>([]);
    const actaPreviewRef = useRef<ActaPreviewRef>(null!);   
    const handleSubmit = async () => {        
        setLoading(true);
        try {
            const consultaLibreDeuda = await api.consultarLibreDeuda(cuitCuil);            
            if (consultaLibreDeuda.length === 0) {
                const template: string = "LibreDeuda";
                const response = await api.pdfLibreDeuda(cuitCuil, template);
                if (response.error) throw new Error();
                setLibreDeuda(response.data);
                setLoading(false);
            }
            setImpagas({ total: consultaLibreDeuda.length, cuitCuil: cuitCuil });            
            const infracciones = consultaLibreDeuda.map((e:any) => {
                const infraccionImpaga = {
                    NroActa: e.id,
                    FechaCreacion: e.fechaHora,
                    Dominio: e.patente,
                    NombreInfractor: e.titular.nombreCompletoTitular,
                    CuilCuitInfractor: e.titular.cuilTitular,
                    DireccionInfractor: e.titular.direccionCompletaTitular,
                    DniInfractor: e.titular.documentoTitular,
                };
                return infraccionImpaga;
            });
            setInfraccionesImpagas(infracciones);
            setLoading(false);
        } catch (error: any | AxiosError) {
            message.error(`Error: ${error.message}`);
        }
        setLoading(false);
    };    
    return (
        <JuzgadoLayout>
            <ActaPreview ref = { actaPreviewRef } />
            <Modal
            width = { "90%" }
            style = {{ maxWidth: "1024px" }}
            bodyStyle = {{ height: "80vh", overflow: "auto" }}
            onCancel = { () => setLibreDeuda(undefined) }
            visible = { libreDeuda !== undefined }
            footer = { null }
            >
                { libreDeuda && <iframe style={{ width: "100%", height: "100%" }} src = { libreDeuda } />}
            </Modal>
            <Paragraph>Ingrese el Cuit/Cuil del titular</Paragraph>            
            <Form.Item>
                    <Input style = {{ width: "40%" }} onChange = { (e) => setCuitCuilt(e.target.value) }/>
                    <br/><br/>
                    <Button onClick = { handleSubmit } type="primary" >Consultar titular</Button>
            </Form.Item>
            {
                impagas.total != 0 ?
                <h3 style = {{ margin: "20px" }}>Se han detectado { impagas.total } infracciones impagas del infractor con Cuit/Cuil { impagas.cuitCuil } </h3> : null                
            }
            {
                infraccionesImpagas.length > 0 ? 
                <Table loading = { loading } dataSource = { infraccionesImpagas.map((e: InfraccionJuzgadoImpaga) => ({ 
                    id: e.NroActa, 
                    fechaCreacion: moment(e.FechaCreacion).format("DD/MM/YYYY"),
                    dominio: e.Dominio,
                    nombreInfractor: e.NombreInfractor,
                    cuilCuitInfractor: e.CuilCuitInfractor,
                    direccionInfractor: e.DireccionInfractor,
                    dniInfractor: e.DniInfractor ? e.DniInfractor : "-"
                })) } columns = {[
                    {
                        title: "Fecha",
                        dataIndex: "fechaCreacion",
                        key: "fechaCreacion"
                    },
                    {
                        title: "Nro. Acta",
                        dataIndex: "id",
                        key: "id"
                    },
                    {
                        title: "Dominio",
                        dataIndex: "dominio",
                        key: "dominio"
                    },
                    {
                        title: "Nombre Completo",
                        dataIndex: "nombreInfractor",
                        key: "nombreInfractor"
                    },
                    {
                        title: "Dni",
                        dataIndex: "dniInfractor",
                        key: "dniInfractor"
                    },
                    {
                        title: "Cuit/Cuil",
                        dataIndex: "cuilCuitInfractor",
                        key: "cuilCuitInfractor"
                    },
                    {
                        title: "Dirección",
                        dataIndex: "direccionInfractor",
                        key: "direccionInfractor"
                    },                    
                ]}>

                </Table>                
                : null
            }
        </JuzgadoLayout>
    );
};

export default LibreDeuda;